import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
} from '@angular/router';
import {
    AppStateFacade,
    UserAuthState,
} from '@app-state';

@Injectable()
export class TenantGuard implements CanActivate {
    constructor(
        private _router: Router,
        private _appState: AppStateFacade,
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ) {
        // this mostly helps the local dev server which doesn't have auth redirect natively
        if (this._appState.user.authState === UserAuthState.NotLoggedIn) {
            this._router.navigate(['account/login'], {
                queryParams: {
                    returnUrl: state.url,
                },
            });
            return false;
        }

        if (route.routeConfig!.path === 'host' && this._appState.user.authState !== UserAuthState.LoggedInAsHost) {
            this._router.navigate(['']);
            return false;
        }
        if (route.routeConfig!.path === '' && this._appState.user.authState !== UserAuthState.LoggedInAsTenant) {
            this._router.navigate(['host']);
            return false;
        }
        return true;
    }
}
